import * as React from 'react'

export const TickSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
      <g id="prefix__Group_11781" data-name="Group 11781" transform="translate(-860 -606.406)">
        <path
          id="prefix__path"
          d="M10.227 10.246l1.51 1.51 4.034-4.036a.842.842 0 1 1 1.191 1.191l-2.436 2.436-2.194 2.194a.842.842 0 0 1-1.19 0l-2.1-2.1a.842.842 0 1 1 1.191-1.191z"
          transform="translate(856.965 606.137)"
        />
      </g>
    </svg>
  )
}
